"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontFormat = exports.getFontFamily = void 0;
var getFontFamily = function (defaultFontFamily, customFont) {
    var fontFamily = '';
    if (customFont === null || customFont === void 0 ? void 0 : customFont.name) {
        fontFamily += "'".concat(customFont === null || customFont === void 0 ? void 0 : customFont.name, "', ");
    }
    if (customFont === null || customFont === void 0 ? void 0 : customFont.fallbackFont) {
        fontFamily += "'".concat(customFont === null || customFont === void 0 ? void 0 : customFont.fallbackFont, "', ");
    }
    fontFamily += defaultFontFamily || '';
    return fontFamily.trim();
};
exports.getFontFamily = getFontFamily;
var getFontFormat = function (fontUrl) {
    if (!fontUrl) {
        return '';
    }
    var fontFileExtensionList = fontUrl.split('.');
    var fontFileExtension = fontFileExtensionList[fontFileExtensionList.length - 1];
    switch (fontFileExtension) {
        case 'woff':
            return 'woff';
        case 'woff2':
            return 'woff2';
        case 'ttf':
            return 'truetype';
        case 'otf':
            return 'opentype';
        default:
            return '';
    }
};
exports.getFontFormat = getFontFormat;
//# sourceMappingURL=fonts.js.map